/**
 * @author Mohit Kukreja <mohit.kukreja@314ecorp.com>
 * @description GuarantorActions
 */
import { Dropdown } from 'antd';
import { MenuItemType } from 'antd/es/menu/interface';
import { MoreOne } from '@icon-park/react';

import Button from 'components/widgets/button';
import { defaultDropdownButtonProps } from './ClaimTableActions';

export interface IProps {
	entityType: StatementEntityType;
	entityId: string;
	entityName: string;
	disabled?: boolean;
}

const GuarantorActions: React.FC<IProps> = ({ entityType, entityId, entityName, disabled = false }) => {
	const schema: MenuItemType[] = [
		{
			key: 'export-statement',
			className: 'tw-dropdown-menu-item',
			disabled,
			label: (
				<Button.ExportStatement
					entityType={entityType}
					entityId={entityId}
					entityName={entityName}
					disabled={disabled}
					{...defaultDropdownButtonProps}
				/>
			),
		},
	];
	return (
		<Dropdown menu={{ items: schema }} trigger={['click']} overlayClassName='claim-actions-dropdown'>
			<Button
				type='default'
				icon={<MoreOne size={20} style={{ paddingTop: 2 }} />}
				onClick={(e) => e.stopPropagation()}
				iconPosition='end'
			/>
		</Dropdown>
	);
};

export default GuarantorActions;
